import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography, Popover, Button, TextField } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import { useDownloadFile } from "../../../../hooks/useDownloadFile";

const useStyles = makeStyles(theme => ({
  downloadButton: {
    minWidth: 140,
    color: theme.palette.common.gamsDarkBlue,
    borderColor: theme.palette.common.gamsDarkBlue,
    "&:hover": {
      backgroundColor: theme.palette.common.blue[600],
      color: theme.palette.common.white
    },
    "&:focus": {
      outline: "none"
    },
    "&:active": {
      backgroundColor: theme.palette.common.blue[600],
      color: theme.palette.common.white
    }
  }
}));

const StepValidatedPopover = ({
  open,
  anchorEl,
  onClose,
  note,
  coachDocumentPath
}) => {
  const classes = useStyles();
  const downloadFileMutation = useDownloadFile();

  const handleDownloadFile = async () => {
    if (coachDocumentPath) {
      try {
        // Scarica il file tramite il servizio backend 
        const blob = await downloadFileMutation.mutateAsync({ url: coachDocumentPath });
        const fileName = coachDocumentPath.split("/").pop() || "coach-document";

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();

        // Clean
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading file:", error);
        window.open(coachDocumentPath, "_blank");
      }
    } else {
      console.warn("No coach document path provided for download");
    }
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center"
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center"
      }}
    >
      <Box style={{ 
        padding: '16px', 
        minWidth: '280px', 
        maxWidth: 'min(500px, 90vw)', 
        width: '100%'
      }}>
        {/* TESTO DESCRITTIVO - Solo se ci sono note */}
        {note && note.trim() !== "" && (
          <>
            <Typography
              variant="body2"
              color="textSecondary"
            >
              Note inserite dal coach
            </Typography>

            {/* AREA DI TESTO CON NOTE (READ-ONLY) */}
            <TextField
              multiline
              minRows={4}
              fullWidth
              variant="outlined"
              margin="normal"
              value={note}
              InputProps={{
                readOnly: true
              }}
            />
          </>
        )}

        {/* BOTTONE DOWNLOAD - Solo se c'è coachDocumentPath */}
        {coachDocumentPath && coachDocumentPath.trim() !== "" && (
          <>
            <Typography
              variant="body2"
              color="textSecondary"
              style={{ marginBottom: "12px", marginTop: "12px" }}
            >
              Immagine caricata dal coach
            </Typography>
            <Box display="flex" justifyContent="center" marginTop={2}>
              <Button
                variant="outlined"
                onClick={handleDownloadFile}
                startIcon={<GetAppIcon />}
                className={classes.downloadButton}
              >
                Download File
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Popover>
  );
};

export default StepValidatedPopover;
